<template>
  <el-dialog
    v-dialogDrag
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="textMap[dialogStatus]"
    :visible.sync="dialogFormVisible"
    :open="unableTableItem()"
    width="35%"
    @closed="clearForm()"
    top="2vh"
  >
    <el-form
      :inline="true"
      :model="listForm"
      ref="listForm"
      :rules="releaseRules"
      label-width="120px"
    >
      
      <el-row>
        <el-col>
          <el-form-item label="参数key" prop="paraKey">
            <el-input :disabled="tableItem" v-model="listForm.paraKey" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col>
          <el-form-item label="value类型" prop="type">
            <el-select :disabled="tableItem" v-model="listForm.type" placeholder="请选择类型">
              <el-option
                v-for="item in valueType"
                :key="item.codeItemId"
                :label="item.codeItemName"
                :value="item.codeItemId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      
      <el-row>
        <el-col>
          <el-form-item v-show="hideFormItem('paraValue')" prop="paraValue" label="参数value">
            <!-- 根据不同的value类型选择不同的情况 -->
            <el-input v-if="listForm.type=='3'" v-model="listForm.paraValue" />
            <el-select @focus="_getValueSelects()" v-if="listForm.type!='3'" multiple v-model="listForm.paraValue" placeholder="请选择类型">
              <el-option
                v-for="item in valueList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col>
          <el-form-item  prop="quotePara" label="引用参数">
            <el-input :disabled="tableItem" v-model="listForm.quotePara" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <!--<el-row>
        <el-col>
          <el-form-item  label="模块名" prop="moduleName">
            <el-input :disabled="tableItem" v-model="listForm.moduleName" />
          </el-form-item>
        </el-col>
      </el-row>-->
      
      <el-row>
        <el-col>
          <el-form-item  label="备注">
            <el-input :disabled="tableItem" type="textarea" :rows="3" v-model="listForm.remark" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <div style="text-align: right">
        <el-button
          type="primary"
          :disabled="btnUnable"
          @click="handlerListForm"
        >
          保存
        </el-button>
        <el-button @click="cancel()">
          取消
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { addParameter, updateParameter, checkParaKeyIsExists, getValueSelects } from "@/api/sys/parameter"

  export default {
    name: "SysParameterDialog",
    props: {
      listForm: {
        type: Object,
        default: () => {
          {}
        }
      },
      // 弹框类型 update、insert
      dialogStatus: {
        type: String,
        default: ""
      },
      // 是否显示标签页
      dialogFormVisible: {
        type: Boolean
      },
      // 标签页类型
      tabType: {
        type: String,
        default: ""
      },
      // 参数类型
      valueType: {
        type: Array,
        default:[]
      }
    },
    created(){
    },
    mounted(){
    },
    watch: {
      // tabType: function(newVal, oldVal) {
      //   this.tabType = newVal;
      // },
      // dialogFormVisible: function (newVal, oldVal) {
      //   // alert(newVal);
      // }
    },
    data() {
      let validatorParaKey = (rule, value, callback) => {
        this.checkisExistsForParaKey(value,this.tabType);
        console.log(this.tabType)
        if (!this.paraKeyIsExists){
          console.log('paraKey后台校验失败')
          callback("参数Key已存在，请修改！");
        } else {
          console.log('paraKey后台校验成功')
          callback();
        }
      };
      return {
        //TODO 模拟当前用户，需要修改成真正的用户
        role: {
          name: 'admin',
          tenantId: 'sys'
        },
        // 禁用
        btnUnable: false,
        tableItem: false,
        tempPropValue:'paraValue',
        // valueType: this.formType, //参数类型
        paraKeyIsExists: {
          type: Boolean,
          default: true
        },

        textMap: {
          add: "新增参数",
          update: "编辑参数"
        },

        valueList: [
        ],


        releaseRules: {
          paraKey: [
            { required: true, message: "参数Key不能为空！", trigger: "blur" },
            { required: true, trigger: "blur", validator: validatorParaKey}
          ],
          paraValue: [
            { required: true, message: "参数value不能为空！", trigger: "blur"}
          ],
          moduleName: [
            { required: true, message: "模块名不能为空！", trigger: "blur"}
          ],
          type: [
            { required: true, message: "参数类型不能为空！", trigger: "change"}
          ]
        }
      };
    },
    methods: {
      handlerListForm() {
        console.log('当前dialog状态为：'+this.dialogStatus)
        console.log('当前tabType为：'+this.tabType)
        console.log('当前tenantId为：'+this.role.tenantId)
        if (this.dialogStatus === "add") {
          this.addForm();
        } else if (this.dialogStatus === "update") {
          this.updateForm();
        }
      },
      addForm() {
        console.log('当前listForm为：'+JSON.stringify(this.listForm))
        this.btnUnable=true
        this.clearValueValidate()
        this.$refs.listForm.validate((valid) => {
          console.log('校验结果'+valid)
          if(valid){
            let tabType=this.tabType
            this.$set(this.listForm,'tabType',tabType)
            addParameter(this.listForm).then(res => {
              console.log('得到的响应结果：'+JSON.stringify(res.data))
              if (res.data.code !== 2){
                this.dialogFormVisible = false;
                this.btnUnable=false
                this.$emit('data-refresh');
                this.$message.success("新增成功！");
              } else {
                this.btnUnable=false
                this.$message.error(res.data.msg);
              }
            })
          }else{
            this.btnUnable=false
          }
        })
      },
      updateForm() {
        console.log('当前listForm为：'+JSON.stringify(this.listForm))
        this.clearValueValidate()
        this.btnUnable=true
        this.$refs.listForm.validate((valid) => {
          if (valid){
            updateParameter(this.listForm).then(res => {
              if (res.data.code !== 2){
                this.btnUnable=false
                this.dialogFormVisible = false;
                this.$emit('data-refresh');
                this.$message.success("编辑成功！");
              } else {
                this.btnUnable=false
                this.$message.error(res.data.msg);
              }
            })
          }else{
            this.btnUnable=false
          }
        })
      },
      checkisExistsForParaKey(value,tabType) {
        checkParaKeyIsExists(value.trim(),tabType.trim()).then(res => {
          this.paraKeyIsExists = res.data.data;
        })
      },
      // 根据value类型获取value下拉选项
      _getValueSelects(){
        let paramTpye=this.listForm.type
        console.log(paramTpye)
        if(paramTpye==undefined||paramTpye==''){
            this.$message.error('请先选择参数类型')
        }else{
          getValueSelects(paramTpye).then((res) => {
            console.log(JSON.stringify(res))
            if(res.status==200){
              this.listForm.paraValue=res.data
            }else{
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      cancel(){
        this.dialogFormVisible = false
        this.$emit('update:dialogFormVisible',false)

      },
      // 隐藏部分表单项
      hideFormItem(param){
        // 当以管理员新增时不需要填写value
        if(this.tabType=='tenant'&&this.role.tenantId=='sys'){
          if(this.dialogStatus=='add'){
            return false;
          }else{
            return true;
          }
        }else{
          return true;
        }
      },
      // 关闭后清空dialog
      clearForm(){
        this.$refs.listForm.resetFields()
        this.$refs.listForm.clearValidate()
      },
      //清楚value的参数校验
      clearValueValidate(){
        if(this.role.tenantId=='sys'){
          this.$set(this.releaseRules, 'paraValue', [])
          // this.$refs.paraValue.clearValidate() 该方式只能清除校验结果而不能在校验行为发生前去除对该项的校验
          console.log('清除paraValue校验')
        }
      },
      // 当租户进修改时只能修改Value，所以禁用掉其他的项
      unableTableItem(){
        if(this.role.tenantId!='sys'){
          console.log('禁用某些table')
          this.tableItem=true
        }
      }
    }
  };

</script>
